import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, X } from 'lucide-react';

export const AdminBanner = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    const user = localStorage.getItem('admin_user');
    setIsAdmin(!!token && !!user);
  }, []);

  if (!isAdmin || dismissed) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[999] bg-[#0B2240] text-white py-2 px-4 flex items-center justify-center gap-3 shadow-lg"
      data-testid="admin-banner"
    >
      <button
        onClick={() => navigate('/admin')}
        className="flex items-center gap-2 text-sm font-medium hover:text-[#E3C96E] transition-colors"
        data-testid="back-to-admin-btn"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Admin Dashboard
      </button>
      <span className="text-xs text-white/50 ml-2">
        You are viewing the public site as an admin
      </span>
      <button
        onClick={() => setDismissed(true)}
        className="ml-4 text-white/50 hover:text-white transition-colors"
        aria-label="Dismiss banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
